<template>
	<div class="columns is-mobile is-padded-left is-padded-right">
		<div class="column is-half-desktop is-full-mobile is-padded-left quotes">
			<b v-html="text"></b>
		</div>
	</div>
</template>

<script>
	export default {
		props : {
			text : {
				type : String,
				required : true,
				default : ''
			}
		}
	}
</script>
